import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function Navigation({ sections }) {
  const location = useLocation();

  return (
    <Box component="nav" role="navigation">
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          marginLeft: 5,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {sections.map((section, index) => (
          <NavLink
            key={`${section.text}_${index}`}
            to={section.link}
            className={() => {
              // Manually set active state since we don't have any top level pages
              return location.pathname.split('/')[1] ===
                section.link.split('/')[1]
                ? 'active'
                : '';
            }}
            style={{
              textDecoration: 'none',
            }}
          >
            <Typography
              variant="span"
              sx={{
                color: 'primary.main',
                display: 'block',
                paddingX: { md: 1.75, lg: 3 },
                paddingY: 0.5,
                position: 'relative',
                borderRadius: '20px 20px 0 20px',
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: 'primary.light',
                },
                '.active &': {
                  fontWeight: 700,
                },
                '.active &:before': {
                  content: '""',
                  width: 68,
                  height: 5,
                  backgroundColor: 'secondary.light',
                  position: 'absolute',
                  bottom: -3,
                  left: '50%',
                  transform: 'translateX(-50%)',
                },
              }}
            >
              {section.text}
            </Typography>
          </NavLink>
        ))}
      </Box>
    </Box>
  );
}
